// assets/component-faq-accordion.js
// Toggles FAQ accordion items open/closed. Animation is CSS-driven; this only
// flips the `is-open` class and aria-expanded. Multiple items may be open at once.
// Re-initialises on shopify:section:load so it keeps working in the Theme Editor.
(() => {
  window.DigitalizModules = window.DigitalizModules || {};
  if (window.DigitalizModules.FaqAccordion) return;

  class FaqAccordion {
    constructor(el) {
      this.el = el;
      this.onClick = this.onClick.bind(this);
      this.init();
    }

    init() {
      this.el.addEventListener('click', this.onClick);
    }

    onClick(event) {
      const toggle = event.target.closest('[data-faq-toggle]');
      if (!toggle || !this.el.contains(toggle)) return;

      const item = toggle.closest('[data-faq-item]');
      if (!item) return;

      const isOpen = item.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    destroy() {
      this.el.removeEventListener('click', this.onClick);
    }
  }

  window.DigitalizModules.FaqAccordion = FaqAccordion;

  // Bind every accordion that isn't bound yet. Runs on first load and again
  // whenever the Theme Editor re-renders a section (shopify:section:load).
  function init() {
    document.querySelectorAll('[data-faq-accordion]').forEach((el) => {
      if (el.dataset.faqBound === 'true') return;
      el.dataset.faqBound = 'true';
      new FaqAccordion(el);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
